import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_CONTENT } from '../content';

const BlogSection = () => {
  const blog = SITE_CONTENT.pages?.homePage?.blogSection || {};
  const subtitle = blog.subtitle || "Our Services";
  const title = blog.title || "Every Celebration, Every Scale";
  const button = blog.button || { label: "Enquire for Your Event", to: "/contact" };
  const posts = blog.posts || [];

  return (
    <section className="bg-[#f0ebe0] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* ── Header row ── */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <div>
            <p className="text-[#1a2e1a] text-[10px] tracking-[0.35em] uppercase font-semibold mb-3">
              {subtitle}
            </p>
            <h2 className="text-[#1a2e1a] text-3xl sm:text-4xl font-light leading-snug">
              {title}
            </h2>
          </div>

          <Link
            to={button.to}
            className="self-start sm:self-auto inline-block px-7 py-3 bg-[#1a2e1a] text-white text-xs tracking-[0.18em] uppercase font-medium rounded-full hover:bg-[#2d4a2d] transition-all duration-300 hover:scale-105 shadow-md"
          >
            {button.label}
          </Link>
        </div>

        {/* ── Cards grid ── */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {posts.map((post) => (
            <Link
              key={post.title}
              to={post.to}
              className="group block"
            >
              {/* Image */}
              <div className="overflow-hidden rounded-sm mb-5 h-[220px] lg:h-[240px]">
                <img
                  src={post.image}
                  alt={post.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
                />
              </div>

              {/* Meta */}
              <div className="flex items-center gap-2 mb-3">
                <span className="text-[#6b6b58] text-[10px] tracking-[0.2em] uppercase font-semibold">
                  {post.category}
                </span>
                <span className="text-[#c8b89a] text-sm select-none">••</span>
                <span className="text-[#6b6b58] text-[10px] uppercase tracking-wide">
                  {post.date}
                </span>
              </div>

              {/* Title */}
              <h3 className="text-[#1a2e1a] text-base font-medium leading-snug mb-2 group-hover:text-[#4a7c59] transition-colors duration-200">
                {post.title}
              </h3>

              {/* Excerpt */}
              <p className="text-[#6b6b58] text-sm leading-relaxed line-clamp-3">
                {post.excerpt}
              </p>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
};

export default BlogSection;
